<template>
  <button
    :type="type"
    :disabled="loading || disabled"
    class="p-btn"
    :class="{
      [`p-btn-${variant}`]: true,
      'w-100': fullWidth,
      'btn-loading': loading,
      'position-relative': withPills
    }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />

    <div
      v-if="withPills"
      class="position-absolute top-50 start-100 translate-middle"
    >
      <pills
        style="outline: 2px solid white;"
        v-bind="pillsProps"
      >
        {{ pillsText }}
      </pills>
    </div>
  </button>
</template>

<script>
import Pills from '~/components/core/Pills'
export default {
  name: 'PButton',
  components: { Pills },
  props: {
    variant: {
      type: String,
      default: 'primary'
    },
    type: {
      type: String,
      default: 'submit'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    withPills: {
      type: Boolean,
      default: false
    },
    pillsText: {
      type: [String, Number],
      default: ''
    },
    pillsProps: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.p-btn {
    padding: 15px 30px;
    font: normal normal normal 14px/16px Arial;
    text-align: center;
    text-transform: uppercase;

    &:disabled,
    &[disabled],
    &[disabled] span,
    &[disabled] p {
        color: #FFFFFF !important;
        background: #909090 !important;
        border: 1px solid #909090 !important;
    }

    &.p-btn-primary {
        background: #313131;
        border: 1px solid #313131;
        color: #FFFFFF;
    }

    &.p-btn-light {
        background: #FFFFFF;
        border: 1px solid #383838;
        color: #383838;
    }
}
</style>
